import type { StatusSnapshot, UptimeHistory, Incident } from './types';

// Resolve API base against the page's URL so the SPA works both at
// status.unreality.is (root mount) and services.unreality.is/status (path mount).
function apiBase(): string {
  // Vite emits assets relative to `base: './'`, so the page pathname
  // already includes any prefix. Strip trailing slash and append /api.
  const p = globalThis.location.pathname.replace(/\/$/, '');
  // Avoid stacking /api/api when running under Vite dev where proxy handles it.
  if (p === '' || p === '/status') return p + '/api';
  return p + '/api';
}

export async function fetchStatus(): Promise<StatusSnapshot> {
  const res = await fetch(`${apiBase()}/status`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`status fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchHistory(): Promise<{ components: UptimeHistory[] }> {
  const res = await fetch(`${apiBase()}/status/history`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`history fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchIncidents(limit = 20): Promise<{ incidents: Incident[] }> {
  const res = await fetch(`${apiBase()}/incidents?limit=${limit}`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`incidents fetch failed: ${res.status}`);
  return res.json();
}
